import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { useState } from 'react';
import { postData, trackCompanyCreated } from '../../../services';
import Modal from '../../helpers/Modal';
export const CreateCompanyForm = ({ onCompanyCreated }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        company_name: '',
        company_type: '',
        street_address_1: '',
        street_address_2: '',
        city: '',
        state: '',
        zip_code: '',
        primary_contact_first_name: '',
        primary_contact_last_name: '',
        primary_contact_email: '',
        primary_contact_phone: '',
    });

    const companyTypes = [
        'MSRP',
        'Distributor',
        'Installer',
        'General Contractor',
        'Other'
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            company_name: formData.company_name,
            company_type: formData.company_type,
            street_address_1: formData.street_address_1,
            street_address_2: formData.street_address_2,
            city: formData.city,
            state: formData.state,
            zip_code: formData.zip_code,
            primary_contact_first_name: formData.primary_contact_first_name,
            primary_contact_last_name: formData.primary_contact_last_name,
            primary_contact_email: formData.primary_contact_email,
            primary_contact_phone: formData.primary_contact_phone,
        };

        try {
            console.log('Creating company');
            const response = await postData(token, `${base_url}/apis/admin/companies`, data);

            if (response && response.company) {
                trackCompanyCreated({
                    companyId: response.company.id,
                    method: 'admin',
                });

                // Call the callback if provided
                if (onCompanyCreated) {
                    onCompanyCreated(response.company);
                }

                // Show success alert
                window.showAlert(200, 'Company created successfully!');
                console.log('Company created successfully!');
                
                // Reset form and close modal
                setFormData({
                    company_name: '',
                    company_type: '',
                    street_address_1: '',
                    street_address_2: '',
                    city: '',
                    state: '',
                    zip_code: '',
                    primary_contact_first_name: '',
                    primary_contact_last_name: '',
                    primary_contact_email: '',
                    primary_contact_phone: '',
                });
                setIsModalOpen(false);
            } else {
                window.showAlert(500, 'Failed to create company. Please try again.');
            }
        } catch (error) {
            console.error('Error creating company:', error);
            
            // Show error alert based on error type
            if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid company data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to create company. Please try again.');
            }
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const createCompanyForm = (
        <div>
            <h2 className="modal-title modal-title--compact">Create Company</h2>
            <form onSubmit={handleSubmit} className="company-form-grid">
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="company_name" className="form-label">
                            Company Name *
                        </label>
                        <input
                            type="text"
                            id="company_name"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter company name"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="company_type" className="form-label">
                            Company Type
                        </label>
                        <select
                            id="company_type"
                            name="company_type"
                            value={formData.company_type}
                            onChange={handleChange}
                            className="form-select"
                        >
                            <option value="">Select company type</option>
                            {companyTypes.map((type, index) => (
                                <option key={index} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="street_address_1" className="form-label">
                            Street Address 1
                        </label>
                        <input
                            type="text"
                            id="street_address_1"
                            name="street_address_1"
                            value={formData.street_address_1}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter primary address"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="street_address_2" className="form-label">
                            Street Address 2
                        </label>
                        <input
                            type="text"
                            id="street_address_2"
                            name="street_address_2"
                            value={formData.street_address_2}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter secondary address (optional)"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="city" className="form-label">
                            City
                        </label>
                        <input
                            type="text"
                            id="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter city"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="state" className="form-label">
                            State
                        </label>
                        <input
                            type="text"
                            id="state"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter state"
                            maxLength="2"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="zip_code" className="form-label">
                            ZIP Code
                        </label>
                        <input
                            type="text"
                            id="zip_code"
                            name="zip_code"
                            value={formData.zip_code}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter ZIP code"
                            maxLength="5"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="primary_contact_first_name" className="form-label">
                            Primary Contact First Name
                        </label>
                        <input
                            type="text"
                            id="primary_contact_first_name"
                            name="primary_contact_first_name"
                            value={formData.primary_contact_first_name}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter first name"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="primary_contact_last_name" className="form-label">
                            Primary Contact Last Name
                        </label>
                        <input
                            type="text"
                            id="primary_contact_last_name"
                            name="primary_contact_last_name"
                            value={formData.primary_contact_last_name}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter last name"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="primary_contact_email" className="form-label">
                            Primary Contact Email
                        </label>
                        <input
                            type="email"
                            id="primary_contact_email"
                            name="primary_contact_email"
                            value={formData.primary_contact_email}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter email address"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="primary_contact_phone" className="form-label">
                            Primary Contact Phone
                        </label>
                        <input
                            type="tel"
                            id="primary_contact_phone"
                            name="primary_contact_phone"
                            value={formData.primary_contact_phone}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter phone number"
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Create Company
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <div>
            <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>
                <FontAwesomeIcon icon={faPlus} className="btn-icon" />  New Company
            </button>
            {isModalOpen && (
                <Modal form={createCompanyForm} setIsModalOpen={setIsModalOpen} isWide fitContent />
            )}
        </div>
    )
};






